import React from 'react';
import {Link} from 'react-router-dom'

function Footer(){
 return(
     <div className='footer'>
         <div>
         <Link to='/admin/login' id='admin_link'><p className='footerFont'>Neu-Gier</p></Link>
         </div>
     </div>
 )
};

export default Footer;